import React, { useEffect, useState } from 'react';
import { Timer, Leaf } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60 + 25);
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    };
    setCurrentDate(now.toLocaleDateString('es-ES', options).toUpperCase());
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="text-[#fdfaf1] py-2 px-4 text-center relative z-[60] overflow-hidden bg-[#1C621C]" data-id="element-309">
      {/* Decorative Herbs */}
      <div className="absolute left-0 top-0 opacity-20 pointer-events-none" data-id="element-310">
        <Leaf className="w-8 h-8 -rotate-45" data-id="element-311" />
      </div>
      <div className="absolute right-0 top-0 opacity-20 pointer-events-none" data-id="element-312">
        <Leaf className="w-8 h-8 rotate-45" data-id="element-313" />
      </div>

      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 md:gap-4 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-314">
        <span className="hidden sm:inline opacity-70" data-id="element-315">{currentDate}</span>
        <span className="hidden sm:inline opacity-30" data-id="element-316">•</span>
        <p className="flex items-center gap-2 text-[11px] font-['DM_Sans',_sans-serif]" data-id="element-317">
          ¡OFERTA RELÁMPAGO! 50% OFF - ÚLTIMOS CUPOS DISPONIBLES
        </p>
        <span className="opacity-30" data-id="element-318">•</span>
        <div className="flex items-center gap-1.5" data-id="element-319">
          <Timer className="w-3 h-3" data-id="element-320" />
          <span className="text-[11px]" data-id="element-321">
            TERMINA EN:{' '}
            <span className="font-black text-[13px] font-['DM_Sans',_sans-serif] text-[#EEF6F2]" data-id="element-322">
              {formatTime(timeLeft)}
            </span>
          </span>
        </div>
      </div>
    </div>;
}